<template style="z-index=1000">
  <el-dialog title="Buscar Cheque" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="400px">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" @submit.native.prevent>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Número do Cheque">
            <el-input v-model="numeroCheque" @keyup.enter.native="buscarChequeHandler"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="text-align: center">
          <el-form-item label=" ">
            <el-button @click="buscarChequeHandler" type="primary" size="small" style="width: 50%" round class="btn-box-shadow">Buscar</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Util from '../../util/funcoes.js';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      numeroCheque: undefined
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado }
    }),
    util() {
      return Util;
    },
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('caixaStore', [
        'recuperarHistoricoCheque'
    ]),

    iniciar(){
      this.numeroCheque = undefined 
    },

    buscarChequeHandler() {
      this.showLoading()

      this.recuperarHistoricoCheque(this.numeroCheque).then(() => {
          this.hideLoading()
          this.fechar()
      }).catch(() => {
        this.hideLoading()
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.fechar()
      });        
    },

    // UTIL
    exibirAlert(titulo, mensagem) {
        this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    fechar() {
      this.$emit('close');
    } 
  }
}
</script>
